import {
    ApiCall,
    API_ACTIONS,
    API_ACTION_TYPES,
    useEventDataOfSelectedEvent,
    EVENT_TYPE,
    SELECTORS,
} from "@Utils";
import { useEffect, useState } from "react";
import { logError } from "repoV2/utils/common/error/error";
import {
    CALL_API_METHODS,
    HTTP_STATUS_SUCCESS_CODES,
} from "repoV2/constants/apis";
import { useSelector } from "react-redux";
import { getWordUsedForCourse } from "@Utils/content/utils";
import { ICurriculum } from "./ICurriculum";

const fetchCurriculum = (listingUuid: string) => {
    const apiInfo =
        API_ACTIONS[API_ACTION_TYPES.GET_RECORDED_CONTENT_CURRICULUM];
    return ApiCall({
        url: apiInfo.url({ listingUuid }),
        method: CALL_API_METHODS.GET,
    });
};

const useCurriculum = () => {
    const hostData = useSelector(SELECTORS.hostData);
    const {
        eventData: { uuid: listingUuid, type, show_curriculum: showCurriculum },
    } = useEventDataOfSelectedEvent();

    const [catalogue, setCatalogue] = useState<
        ICurriculum.ICatalogueItem[] | undefined
    >();

    useEffect(() => {
        if (type === EVENT_TYPE.RECORDED_CONTENT && showCurriculum)
            fetchCurriculum(listingUuid)
                .then((apiResponse: any) => {
                    const { status, data, message } = apiResponse?.data || {};
                    // status code 204 is intentionally added
                    if (
                        status !== HTTP_STATUS_SUCCESS_CODES.HTTP_STATUS_OK &&
                        status !==
                            HTTP_STATUS_SUCCESS_CODES.HTTP_STATUS_NO_CONTENT
                    )
                        throw new Error(message);
                    if (data?.catalogue) setCatalogue(data.catalogue);
                })
                .catch(error =>
                    logError({
                        error,
                        occuredAt: "useCurriculum",
                        when: "fetchCurriculum",
                        severity: "critical",
                    })
                );
    }, []);

    return {
        catalogue,
        showCurriculum,
        wordUsedForCourse: getWordUsedForCourse(hostData),
    };
};

export default useCurriculum;
